/* jshint esversion: 6 */

export default class GalleryCounter {

	constructor() {
		this.restrict = 'A';
	}

	link(scope, element, attributes, controller) {
		var items = element[0].querySelectorAll('.gallery__item');
		var counterLabel = element[0].querySelector('.counter-label');
		if (items.length && counterLabel) {
			counterLabel.textContent = items.length;
		}
	}

	static factory() {
		return new GalleryCounter();
	}

}

GalleryCounter.factory.$inject = [];
